var _dec, _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
/**
## Global Address model

### Related utils
-- addresses: Defines address form formats for various countries
-- global_address: Helper functions for string formatting an address
*/

import { computed } from '@ember/object';
import { isBlank, isNone } from '@ember/utils';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { Country as CountryProtoEnum } from '@square/dashboard-protos/models/squareup/common/countries';
import { Country } from '@square/dashboard-data/models/squareup/common/countries';
const Attrs = ProtoBaseModel.extend({
  addressLine1: attr(String, {
    key: 'address_line_1'
  }),
  // street 1
  addressLine2: attr(String, {
    key: 'address_line_2'
  }),
  // street 2
  addressLine3: attr(String, {
    key: 'address_line_3'
  }),
  addressLine4: attr(String, {
    key: 'address_line_4'
  }),
  addressLine5: attr(String, {
    key: 'address_line_5'
  }),
  locality: attr(String),
  // city
  sublocality: attr(String),
  sublocality1: attr(String, {
    key: 'sublocality_1'
  }),
  sublocality2: attr(String, {
    key: 'sublocality_2'
  }),
  sublocality3: attr(String, {
    key: 'sublocality_3'
  }),
  sublocality4: attr(String, {
    key: 'sublocality_4'
  }),
  sublocality5: attr(String, {
    key: 'sublocality_5'
  }),
  administrativeDistrictLevel1: attr(String, {
    key: 'administrative_district_level_1'
  }),
  // state
  administrativeDistrictLevel2: attr(String, {
    key: 'administrative_district_level_2'
  }),
  administrativeDistrictLevel3: attr(String, {
    key: 'administrative_district_level_3'
  }),
  postalCode: attr(String),
  // zip
  countryCode: attr(Country),
  addressCoordinates: attr(Object) // TODO: squareup.common.location.Coordinates
});
let GlobalAddress = (_dec = computed('addressLine1', 'addressLine2', 'addressLine3', 'addressLine4', 'addressLine5', 'locality', 'sublocality', 'sublocality1', 'sublocality2', 'sublocality3', 'sublocality4', 'sublocality5', 'administrativeDistrictLevel1', 'administrativeDistrictLevel2', 'administrativeDistrictLevel3', 'postalCode'), (_class = class GlobalAddress extends Attrs {
  constructor(...args) {
    super(args);
  }

  // TODO: convert this property into a helper function in utils/global_address.
  get formatted() {
    return [this.addressLine1, this.addressLine2, this.addressLine3, this.addressLine4, this.addressLine5, this.locality, this.sublocality, this.sublocality1, this.sublocality2, this.sublocality3, this.sublocality4, this.sublocality5, this.administrativeDistrictLevel1, this.administrativeDistrictLevel2, this.administrativeDistrictLevel3, this.postalCode].filter(item => !isBlank(item)).join(', ');
  }

  /**
   * Converts a squareup.connect.v2.resources.Address proto into a GlobalAddress.
   *
   * @param {squareup.connect.v2.resources.Address} proto
   * @returns {GlobalAddress}
   */
  static fromConnectAddressProto(proto) {
    if (isNone(proto)) {
      return null;
    }
    return this.create({
      addressLine1: proto.addressLine1,
      addressLine2: proto.addressLine2,
      addressLine3: proto.addressLine3,
      locality: proto.locality,
      sublocality: proto.sublocality,
      sublocality1: proto.sublocality2,
      sublocality2: proto.sublocality3,
      administrativeDistrictLevel1: proto.administrativeDistrictLevel1,
      administrativeDistrictLevel2: proto.administrativeDistrictLevel2,
      administrativeDistrictLevel3: proto.administrativeDistrictLevel3,
      postalCode: proto.postalCode,
      countryCode: CountryProtoEnum[proto.country]
    });
  }

  /**
   * Converts a catalog address into a GlobalAddress.
   *
   * @param {models/connect/address} catalogAddress
   * @returns {GlobalAddress}
   */
  static fromCatalogAddress(catalogAddress) {
    if (isNone(catalogAddress)) {
      return null;
    }
    return this.create({
      addressLine1: catalogAddress.addressLine1,
      addressLine2: catalogAddress.addressLine2,
      addressLine3: catalogAddress.addressLine3,
      locality: catalogAddress.locality,
      sublocality: catalogAddress.sublocality,
      sublocality1: catalogAddress.sublocality2,
      sublocality2: catalogAddress.sublocality3,
      administrativeDistrictLevel1: catalogAddress.administrativeDistrictLevel1,
      administrativeDistrictLevel2: catalogAddress.administrativeDistrictLevel2,
      administrativeDistrictLevel3: catalogAddress.administrativeDistrictLevel3,
      postalCode: catalogAddress.postalCode,
      countryCode: Country[catalogAddress.country]
    });
  }
}, (_applyDecoratedDescriptor(_class.prototype, "formatted", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "formatted"), _class.prototype)), _class));
export { GlobalAddress as default };